module.exports = __webpack_public_path__ + "static/kruthik-c81199e69303d402f714a461c8f62dd1.png";